import type { FC } from "react";

import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import WWOSearchTrafficCompare from "app/pages/website-performance/components/SearchTraffic/compare/WWOSearchTrafficCompare";
import { getKeywordsCtaLinkForSI } from "app/pages/website-performance/components/SearchTraffic/utlis";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";

interface IWWOSearchTrafficCompareProps {
    organic: boolean;
    hideFooter?: boolean;
}

export const WWOSearchTrafficCompareContainerSI: FC<IWWOSearchTrafficCompareProps> = (props) => {
    return (
        <WWOSearchTrafficCompare
            getCtaLink={getKeywordsCtaLinkForSI(
                props.organic
                    ? WEBSITE_ANALYSIS_WIDGET_NAMES.trafficKeywords
                    : WEBSITE_ANALYSIS_WIDGET_NAMES.paidSearchKeywords,
            )}
            unlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            renderTextInsteadOfLinks
            {...props}
        />
    );
};
